define('LearningLibrarySearchResults/learningLibrarySearchResults',[
    "common/urlUtils",   
    "LearningLibrarySearchResults/searchCount",
    "common/formUtils"
],
    function (urlUtils, searchCount, formUtils) {

        var lastSearch;
        var firstLoad = true;

        function getSearchResults(keyword, topics, tags, contentTypes, pageNumber, tagsInfo, scrollToTop) { 
            var queryParams = urlUtils.parseQueryParamsFromUrl();
            setParametersOnResultsComponent(queryParams, keyword, topics, tags, contentTypes);
            var searchParams = getSearchParams(queryParams, pageNumber);  
            var setSearchParamsIntoUrl = $("#search-results-container").data("putSearchParametersIntoUrl");
            setUrlWithoutPageLoading(searchParams, queryParams, setSearchParamsIntoUrl);
            if (firstLoad) {
                firstLoad = false;
                refreshSearchCountComponent(searchParams.Keyword, tagsInfo, searchParams);
                refreshFacetsCount();
                HandlePagingText();
                return;
            }
                    
            lastSearch = searchParams;            
            var placeholdersDiv = $(".placeholders").clone();           
            $("#search-results").find('div:not(".search-paging")').remove();
            $("#search-results").prepend(placeholdersDiv);            
            $("#search-results .placeholders").css("display", "");   
            if (scrollToTop)
                $("#content").get(0).scrollIntoView();       
            formUtils.useToken(searchParams);
           
            $.ajax({
                type: "POST",
                url: "/customapi/LearningLibrary/LearningLibraryAjaxSearchResults",
                dataType: "text",
                data: searchParams,
                success: function (data) {  
                    if (lastSearch !== searchParams) {
                        return;
                    }                                          
                    $("#search-results").html(data);                                                       
                    refreshSearchCountComponent(searchParams.Keyword, tagsInfo, searchParams);
                    refreshFacetsCount();
                    //if (scrollToTop)
                    //    $("#content").get(0).scrollIntoView();                        
                    var hasResults = $("#hdnSearchHasResults").val();
                    if (hasResults == "False")
                        $(".no-results").show();
                    else
                        $(".no-results").hide();
                    HandlePagingText();
                },
                error: function (jq, status, errorThrown) {
                    if (lastSearch !== searchParams) {
                        return;
                    }
                },
                complete: function () { 
                    if (lastSearch !== searchParams) {
                        return;
                    }
                    $("#search-results .placeholders").hide();                        
                }
            });
        }

        function refreshFacetsCount() {              
            $('span[id^="span_"]').each(function (index, element) {               
                $(element).text("");                
            });      

            if (resultFacets) {
                for (var i = 0; i < resultFacets.length; i++) {
                    var facet = resultFacets[i];
                    var facetTextElement = $("#span_" + facet.Name);                   
                    if (facetTextElement.length) {
                        if (facet.Count != 0)
                            facetTextElement.text(" (" + facet.Count + ")");
                        else
                            facetTextElement.text("");
                    }
                }
            }
        }

        function getTagInfoObjects(queryParam, tagsInfo) {
            if (queryParam) {
                const urlParamSeparator = "|";
                var parameterValues = queryParam.split(urlParamSeparator);                
                for (var i = 0; i < parameterValues.length; i++) {
                    $("#" + parameterValues[i]).prop("checked", true);       
                    var spantextElement = $("#spantext_" + parameterValues[i]);
                    if (spantextElement.length) {
                        var label = $("#spantext_" + parameterValues[i]).text();
                        tagsInfo.push({ "TagId": $("#" + parameterValues[i]).val(), "TagGroupName": $("#" + parameterValues[i]).attr("title"), "TagText": label });
                    }
                }
            }
        }

        function refreshSearchCountComponent(keyword, tagsInfo, searchParams) {          
            if (tagsInfo == null || tagsInfo == undefined) {
                tagsInfo = [];
                if (searchParams.Tags)
                    getTagInfoObjects(searchParams.Tags, tagsInfo);
                if (searchParams.ContentTypes)
                    getTagInfoObjects(searchParams.ContentTypes, tagsInfo);               
            }
            searchCount.displayCountResults($("#hdnTotalResults").val(), keyword, tagsInfo);
        }

        function setUrlWithoutPageLoading(searchParams, queryParams, setSearchParamsIntoUrl) { 
            var url = window.location.pathname;
            if (setSearchParamsIntoUrl == "True") {
                if (searchParams.Keyword)
                    url = urlUtils.putParamIntoUrl("keyword", searchParams.Keyword, url);
                //to remove topics from url comment this
                //if (searchParams.Topics)
                //    url = urlUtils.putParamIntoUrl("topics", searchParams.Topics, url);               
                if (searchParams.Tags)
                    url = urlUtils.putParamIntoUrl("tags", searchParams.Tags, url);
                if (searchParams.ContentTypes) {                                       
                    if (searchParams.ContentTypes != $("#search-results-container").data("predefinedContentTypes"))
                        url = urlUtils.putParamIntoUrl("contenttypes", searchParams.ContentTypes, url);                                           
                }
            }

            if (searchParams.PageNumber)               
                url = urlUtils.putParamIntoUrl("page", (searchParams.PageNumber + 1).toString(), url);
           
            history.replaceState("", document.title, url);
        }

        function HandlePagingText() {
            $("#paging-first").text($("#search-results-container").data("pagingFirst"));
            $("#paging-previous").text($("#search-results-container").data("pagingPrevious"));
            $("#paging-next").text($("#search-results-container").data("pagingNext"));
            $("#paging-last").text($("#search-results-container").data("pagingLast"));
        }

        function htmlEncode(value) {
            //create a in-memory div, set it's inner text(which jQuery automatically encodes)
            //then grab the encoded contents back out. The div never exists on the page.
            return $('<div/>').text(value).html();
        }

        function htmlDecode(value) {
            return $('<div/>').html(value).text();
        }

        function setParametersOnResultsComponent(queryParams, keyword, topics, tags, contentTypes) {          
            if (queryParams) {
                if (!$.isEmptyObject(queryParams)) {
                    if (queryParams.keyword)
                        $("#search-results-container").data("keyword", htmlEncode(queryParams.keyword));                    
                    if (queryParams.topics)
                        $("#search-results-container").data("topics", queryParams.topics);
                    if (queryParams.tags)
                        $("#search-results-container").data("tags", queryParams.tags);
                    if (queryParams.contenttypes)
                        $("#search-results-container").data("contentTypes", queryParams.contenttypes);
                }
            }
           
            if (keyword != null)
                $("#search-results-container").data("keyword", htmlEncode(keyword));
            if (topics != null)
                $("#search-results-container").data("topics", topics);
            if (tags != null)
                $("#search-results-container").data("tags", tags);
            if (contentTypes != null)
                $("#search-results-container").data("contentTypes", contentTypes);
        }

        function getSearchParams(queryParams, pageNumber) {   
            var mustHaveAnyTopicString = $("#search-results-container").data("mustHaveAnyTopic");
            var mustHaveAnyTopic = false;
            if (mustHaveAnyTopicString && mustHaveAnyTopicString == "True")
                mustHaveAnyTopic = true;

            var productSupportContentOnlyString = $("#search-results-container").data("productSupportContentOnly");
            var productSupportContentOnly = false;
            if (productSupportContentOnlyString && productSupportContentOnlyString == "True")
                productSupportContentOnly = true;

            var searchParams = {
                "Keyword": htmlDecode($("#search-results-container").data("keyword")),
                "PageSize": $("#search-results-container").data("pageSize"),
                "Topics": $("#search-results-container").data("topics"),
                "Tags": $("#search-results-container").data("tags"),
                "ContentTypes": $("#search-results-container").data("contentTypes"),
                "NumberOfTilesPerRow": $("#search-results-container").data("numberOfTilesInRow"),
                "MustHaveAnyTopic": mustHaveAnyTopic,
                "ProductSupportContentOnly": productSupportContentOnly
            };

            if (queryParams.page)
                searchParams.PageNumber = parseInt(queryParams.page) -1;
            if (pageNumber != null && pageNumber != undefined)
                searchParams.PageNumber = pageNumber;              
            if (!searchParams.ContentTypes)
                searchParams.ContentTypes = $("#search-results-container").data("predefinedContentTypes");

            return searchParams;
        }

        goToPage = function (pageNumber) {
            getSearchResults(null, null, null, null, pageNumber, null, true);
        }

        return {
            getSearchResults: getSearchResults
        };
});

